import styled from 'styled-components';

export const SubCategorySection = styled.div`
  margin: 16px 0;
`;
